var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.613,
    height: 23,
    viewBox: "0 0 122.613 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1227",
    "data-name": "Group 1227",
    transform: "translate(642.38 1381.609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(-579.843 -1381.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M-47.958-1378.616h-3.964a.338.338,0,0,0-.358.358v8.07a.19.19,0,0,1-.215.214h-3.392a.19.19,0,0,1-.215-.214v-8.07a.338.338,0,0,0-.358-.358h-3.964a.338.338,0,0,0-.358.358v21.3a.338.338,0,0,0,.358.357h3.964a.338.338,0,0,0,.358-.357v-8.589a.19.19,0,0,1,.215-.214h3.392a.19.19,0,0,1,.215.214v8.589a.338.338,0,0,0,.358.357h3.964a.338.338,0,0,0,.358-.357v-21.3A.338.338,0,0,0-47.958-1378.616Z",
    transform: "translate(60.779 1378.938)",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M377.39-1356.957l-5.464-11.874,4.856-9.428a.221.221,0,0,0-.179-.358H372.46a.459.459,0,0,0-.463.286l-4.429,9.392v-9.321a.338.338,0,0,0-.358-.358h-3.964a.336.336,0,0,0-.356.358v21.3a.336.336,0,0,0,.356.357h3.964a.338.338,0,0,0,.358-.357v-4.3l1.429-3,3.571,7.411c.036.179.143.25.358.25h4.25A.246.246,0,0,0,377.39-1356.957Z",
    transform: "translate(-317.336 1378.938)",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M232.489-1377.5c-.892-2.678-3.036-4.107-6.215-4.107s-5.321,1.429-6.213,4.107c-.372,1.047-.488,2-.5,7.393.011,5.392.125,6.346.5,7.393.892,2.678,3.036,4.107,6.215,4.107s5.321-1.429,6.213-4.107c.372-1.047.488-2,.5-7.393C232.975-1375.5,232.861-1376.455,232.489-1377.5Zm-4.253,7.393c-.007,5-.08,5.568-.249,6.107a1.7,1.7,0,0,1-1.713,1.178A1.7,1.7,0,0,1,224.56-1364c-.169-.54-.242-1.108-.249-6.107h0c.007-5,.08-5.568.249-6.108a1.7,1.7,0,0,1,1.713-1.178,1.7,1.7,0,0,1,1.715,1.178c.169.54.242,1.108.249,6.108Z",
    transform: "translate(-189.418 1381.609)",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M90.778-1377.5c-.892-2.678-3.036-4.107-6.215-4.107s-5.321,1.429-6.213,4.107c-.372,1.047-.488,2-.5,7.393.011,5.392.125,6.346.5,7.393.892,2.678,3.036,4.107,6.215,4.107s5.321-1.429,6.213-4.107c.372-1.047.488-2,.5-7.393C91.264-1375.5,91.15-1376.455,90.778-1377.5Zm-4.253,7.393c-.006,5-.08,5.568-.249,6.107a1.7,1.7,0,0,1-1.713,1.178A1.7,1.7,0,0,1,82.849-1364c-.169-.54-.242-1.108-.249-6.107h0c.007-5,.08-5.568.249-6.108a1.7,1.7,0,0,1,1.713-1.178,1.7,1.7,0,0,1,1.715,1.178c.169.54.242,1.108.249,6.108Z",
    transform: "translate(-62.945 1381.609)",
    fill: "#B1B1B1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M-629.666-1376.992c-.892-2.749-2.857-4.035-6.214-4.035h-6.143a.338.338,0,0,0-.357.358v21.3a.338.338,0,0,0,.357.358h6.143c3.357,0,5.321-1.286,6.214-4.035.4-1.252.608-2.746.638-6.973C-629.059-1374.245-629.271-1375.74-629.666-1376.992Zm-4.5,12.266a1.981,1.981,0,0,1-2.178,1.5h-1.142a.19.19,0,0,1-.215-.214V-1376.6a.19.19,0,0,1,.215-.214h1.142a1.982,1.982,0,0,1,2.178,1.5c.261.683.372,1.605.389,5.293C-633.794-1366.331-633.9-1365.408-634.166-1364.725Z",
    transform: "translate(0 -0.331)",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(-626.735 -1381.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M-483.026-1356.957l-3.322-8.017c1.679-1.143,2.714-3.143,2.714-6.213,0-5.392-2.786-7.429-7.105-7.429h-5.786a.338.338,0,0,0-.358.358v21.3a.338.338,0,0,0,.358.357h3.964a.338.338,0,0,0,.357-.357v-6.66a.19.19,0,0,1,.215-.215h1.357l2.748,6.946a.354.354,0,0,0,.393.286h4.286C-483.026-1356.6-482.955-1356.778-483.026-1356.957Zm-7.928-10.91h-1.035a.19.19,0,0,1-.215-.215v-6.213a.19.19,0,0,1,.215-.215h1.035c1.82,0,2.607.785,2.607,3.322C-488.347-1368.616-489.134-1367.867-490.954-1367.867Z",
    transform: "translate(496.883 1378.938)",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M-341.648-1377.5c-.892-2.678-3.036-4.107-6.215-4.107s-5.321,1.429-6.213,4.107c-.372,1.047-.488,2-.5,7.393.011,5.392.125,6.346.5,7.393.892,2.678,3.036,4.107,6.215,4.107s5.321-1.429,6.213-4.107c.372-1.047.488-2,.5-7.393C-341.162-1375.5-341.276-1376.455-341.648-1377.5Zm-4.253,7.393c-.006,5-.08,5.568-.249,6.107a1.7,1.7,0,0,1-1.713,1.178,1.7,1.7,0,0,1-1.715-1.178c-.169-.54-.242-1.108-.249-6.107h0c.006-5,.08-5.568.249-6.108a1.7,1.7,0,0,1,1.713-1.178,1.7,1.7,0,0,1,1.715,1.178c.169.54.242,1.108.249,6.108Z",
    transform: "translate(369.877 1381.609)",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M-198.721-1378.616h-5.714a.338.338,0,0,0-.358.358v21.3a.338.338,0,0,0,.358.357h3.964a.338.338,0,0,0,.358-.357v-6.161a.189.189,0,0,1,.215-.213h1.178c4.321,0,7.141-2.144,7.141-7.643C-191.58-1376.51-194.292-1378.616-198.721-1378.616Zm-.143,11.178H-199.9a.19.19,0,0,1-.215-.214v-6.642a.19.19,0,0,1,.215-.215h1.035c1.822,0,2.607.785,2.607,3.535S-197.042-1367.438-198.864-1367.438Z",
    transform: "translate(236.2 1378.938)",
    fill: "#FCFCFC"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ce420d18.svg";
export { ForwardRef as ReactComponent };